<template>
    <Modal  v-model="editSchedulesModal" :title="$t('configuration_management.schedules.editSchedule')" @on-ok="schedulesSubmit('schedulesEditForm')"
            :okText="$t('common.edit')" :cancelText="$t('alarms.common.cancel')"
            @on-cancel="schedulesReset('schedulesEditForm')" :loading="loading" :mask-closable="false" :on-open-modal="editSchedulesModal=true">
        <Form ref="schedulesEditForm" :model="schedulesEditForm" :label-width="100" :rules="ruleValidate">
            <!-- 名称 -->
            <FormItem :label="$t('configuration_management.schedules.name')" prop="name">
                <Input v-model="schedulesEditForm.name" placeholder="Enter something..." style="width:300px;"></Input>
            </FormItem>

            <!-- 重复 -->
            <Row>
                <Col span="11" style="z-index:100;">
                    <FormItem :label="$t('configuration_management.schedules.repetition')" prop="frequencyNum">
                        <InputNumber :max="100" :min="1" v-model="schedulesEditForm.frequencyNum"></InputNumber>
                    </FormItem>
                </Col>
                <Col span="12" style="z-index:50;margin-left: -100px;">
                    <FormItem prop="frequencyUnit">
                        <Select v-model="schedulesEditForm.frequencyUnit">
                          <Option value="0">{{ $t('configuration_management.schedules.minute') }}</Option>
                          <Option value="1">{{ $t('configuration_management.schedules.hour') }}</Option>
                          <Option value="2">{{ $t('configuration_management.schedules.day') }}</Option>
                          <Option value="3">{{ $t('configuration_management.schedules.week') }}</Option>
                          <Option value="4">{{ $t('configuration_management.schedules.month') }}</Option>
                        </Select>
                    </FormItem>
                </Col>
            </Row>

            <!-- 开始时间 -->
            <FormItem :label="$t('configuration_management.schedules.start')" prop="scheduleStartTime">
                <DatePicker type="datetime" placeholder="Select date and time" style="width: 200px" v-model="schedulesEditForm.scheduleStartTime" :options="startTimeOptions" ></DatePicker>
            </FormItem>

            <!-- 结束时间 -->
            <FormItem :label="$t('configuration_management.schedules.end')" prop="scheduleEndTime">
                <!-- <a href="#">从不(点击修改)</a> -->
                <DatePicker type="datetime" placeholder="Select date and time" style="width: 200px" v-model="schedulesEditForm.scheduleEndTime" :options="endTimeOptions" ></DatePicker>
            </FormItem>

            <!-- 启用于 -->
            <FormItem :label="$t('configuration_management.schedules.startFor')" prop="enableWeekdays">
                <CheckboxGroup v-model="schedulesEditForm.enableWeekdays">
                  <Checkbox label="1">{{ $t('configuration_management.schedules.Monday') }}</Checkbox>
                  <Checkbox label="2">{{ $t('configuration_management.schedules.Tuesday') }}</Checkbox>
                  <Checkbox label="3">{{ $t('configuration_management.schedules.Wednesday') }}</Checkbox>
                  <Checkbox label="4">{{ $t('configuration_management.schedules.Thursday') }}</Checkbox>
                  <Checkbox label="5">{{ $t('configuration_management.schedules.Friday') }}</Checkbox>
                  <Checkbox label="6">{{ $t('configuration_management.schedules.Saturday') }}</Checkbox>
                  <Checkbox label="0">{{ $t('configuration_management.schedules.Sunday') }}</Checkbox>
                </CheckboxGroup>
            </FormItem>

            <!-- 描述 -->
            <FormItem :label="$t('configuration_management.schedules.describe')" prop="description">
                <Input v-model="schedulesEditForm.description" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="Enter something..." style="width:300px;"></Input>
            </FormItem>

        </Form>
    </Modal>
</template>
<script>
    export default {
        name: 'EditSchedules',
        props:['schedulesEditOldForm'],
        data () {
            return {
                schedulesEditForm: {
                    name: '',
                    frequencyNum: 0,
                    frequencyUnit: '',
                    scheduleStartTime: '',
                    scheduleEndTime: '',
                    enableWeekdays: ["星期天","星期一","星期二","星期三","星期四","星期五","星期六"],
                    description: ''
                },
                Monday:false,
                Tuesday:false,
                Wednesday:false,
                Thursday:false,
                Friday:false,
                Saturday:false,
                Sunday:false,
                startTimeOptions: {}, //开始日期设置
                endTimeOptions: {}, //结束日期设置
                editSchedulesModal:false,
                loading: true,
                value1: '',
                value2: '',
                ruleValidate: {
                    name: [
                        { required: true, message: this.$t('configuration_management.schedules.nameRequired'), trigger: 'blur'},
                        { type: 'string', message: this.$t('configuration_management.schedules.namePattern'), pattern:'^.{8,20}$', trigger: 'blur'}
                    ],
                    frequencyNum: [
                        { required: true, message: this.$t('configuration_management.schedules.frequencyNumRequired'), trigger: 'blur',type: 'number'}
                    ],
                    frequencyUnit: [
                        { required: true, message: this.$t('configuration_management.schedules.frequencyUnitRequired'), trigger: 'change'}
                    ],
                    scheduleStartTime: [
                        { required: true, message: this.$t('configuration_management.common.pleaseSelectStartTime'), trigger: 'blur',type: 'date'}
                    ],
                    scheduleEndTime: [
                        { required: true, message: this.$t('configuration_management.common.pleaseSelectEndTime'), trigger: 'blur',type: 'date'}
                    ],
                    enableWeekdays: [
                         { required: true, type: 'array', min: 1, message: this.$t('configuration_management.schedules.atLeastOne'), trigger: 'change' },
                         { type: 'array', max: 7, message: this.$t('configuration_management.schedules.atMostSeven'), trigger: 'change' }
                    ],
                    description: [
                        { required: false, message: this.$t('configuration_management.schedules.pleaseEnterDescribe'), trigger: 'blur'},
                        { type: 'string', max: 100, message: this.$t('configuration_management.common.max100Characters'), trigger: 'blur' }
                    ]
                },
                startTimeOptions: {
                    disabledDate: (date)=> {
                        if(Date.now() >  this.schedulesEditForm.scheduleStartTime){
                            return true;
                        }else if(Date.now() <  this.schedulesEditForm.scheduleStartTime){
                            return date && date.valueOf() < Date.now() - 86400000;
                        }
                    }
                },
                endTimeOptions: {
                    disabledDate (date) {
                        return date && date.valueOf() < Date.now() - 86400000;
                    }
                }
            }
        },
        mounted:function(){
            this.schedulesShow();
        },
        methods: {
            schedulesShow:function(){
                //当前行id
                this.schedulesEditForm.id=this.schedulesEditOldForm.id;
                //名称
                this.schedulesEditForm.name=this.schedulesEditOldForm.name;
                //重复数字
                this.schedulesEditForm.frequencyNum=this.schedulesEditOldForm.frequencyNum; 
                //重复频率
                this.schedulesEditForm.frequencyUnit=this.schedulesEditOldForm.frequencyUnit+"";
                //开始时间
                this.schedulesEditForm.scheduleStartTime=this.schedulesEditOldForm.scheduleStartTime;
                //结束时间
                this.schedulesEditForm.scheduleEndTime=this.schedulesEditOldForm.scheduleEndTime;
                //启用于
                //schedulesEditOldForm.enableWeekdays 为原始下标字符串(形如 ["0","1"]),
                //直接解析下标,避免依赖本地化后的显示文本(中英文 locale 均可正确回填)
                var raw = this.schedulesEditOldForm.enableWeekdays;
                var indexArr = [];
                if (raw != null && raw !== "") {
                    indexArr = String(raw)
                        .replace(/[\[\]"]/g, "")
                        .split(",");
                }
                //该数组用来记下标，因为传给后台的是下标
                var arr=[];
                //原数组
                //本页面数组
                //判断原来的数据的下标是多少，push到arr数组中
                //根据下标修改页面上的效果，顺便push一下，注意他的是字符串格式 ""强制类型转换
                for(var i=0;i<indexArr.length;i++){
                    var idx = (indexArr[i] + "").trim();
                    if(idx === "") continue;
                    //根据下标修改页面上的效果，注意他的是字符串格式 ""强制类型转换
                    switch(idx){
                        case "0":this.Sunday=true;break;
                        case "1":this.Monday=true;break;
                        case "2":this.Tuesday=true;break;
                        case "3":this.Wednesday=true;break;
                        case "4":this.Thursday=true;break;
                        case "5":this.Friday=true;break;
                        case "6":this.Saturday=true;break;
                        default:break;
                    }
                    arr.push(idx);
                }
                // 将获取到的数组赋值要用的那个数组里
                this.schedulesEditForm.enableWeekdays=arr;
                // 描述
                this.schedulesEditForm.description=this.schedulesEditOldForm.description;
            },
            schedulesSubmit: function(name){
                this.$refs[name].validate(valid => {
                    if(valid){
                        // 编辑日程
                        this.$api.scheduleManagement.updateSchedule({
                            "id":this.schedulesEditForm.id,
                            "name": this.schedulesEditForm.name,
                            "frequencyNum": this.schedulesEditForm.frequencyNum,
                            "frequencyUnit": this.schedulesEditForm.frequencyUnit,
                            "scheduleStartTime": this.schedulesEditForm.scheduleStartTime,
                            "scheduleEndTime": this.schedulesEditForm.scheduleEndTime,
                            "enableWeekdays": JSON.stringify(this.schedulesEditForm.enableWeekdays),
                            "description": this.schedulesEditForm.description
                        })
                        .then(res => {
                            this.data = res.data;
                            setTimeout(() => {
                                // 子组件引用父组件methods里面的方法
                                this.$parent.showAll();
                                this.$refs[name].resetFields();
                                this.loading = false;
                                this.$nextTick(() => {
                                    this.loading = true;
                                });
                                this.$Message.success(this.$t('common.editSuccess'));
                                this.$emit("on-close-cancel",false);
                                this.editSchedulesModal = false;
                            },1000);
                        })
                    }else{
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.loading = false;
                        setTimeout(() => {
                            this.loading = true
                        }, 0)
                        this.$Message.error(this.$t('common.editFail'));
                    }
                });
            },
            schedulesReset: function(name){
                this.$emit("on-close-cancel",false);
                this.$refs[name].resetFields();
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/schedules/EditSchedules.vue